// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2U6HS","label":"Category_label__1RHE3","content":"Category_content__1LiZe","header":"Category_header__2L5HG","location":"Category_location__Ns0sb"};